import { DataSource, Image, Layout } from "@mcleod/components";

export abstract class AutogenLayoutStopShowAsButton extends Layout {
    imageShowAs: Image;
    sourceStop: DataSource;
}
